var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnpinLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79803 8.05653L7.06547 8.78909L5.19447 8.80465L4.54676 9.45236L6.90354 11.8091L3.95703 14.7557V15.4034L4.60545 15.4041L7.55196 12.4576L9.90875 14.8144L10.5565 14.1666L10.5713 12.2949L11.3039 11.5624L10.6562 10.9147L9.62873 11.9421L9.64288 13.2531L6.10734 9.71752L7.41903 9.73237L8.44645 8.70495L7.79803 8.05653ZM12.7775 8.79334L14.1365 7.43428L11.9268 5.22457L10.5678 6.58363L9.91935 5.93521L11.2784 4.57615L10.6894 3.98713L11.3378 3.33871L16.0224 8.0233L15.374 8.67171L14.7843 8.08199L13.4252 9.44105L12.7775 8.79334Z",
    fill: "#181818"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.47656,
    y: 3.76904,
    width: 12.6533,
    height: 1,
    transform: "rotate(45 6.47656 3.76904)",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinLine);
export default __webpack_public_path__ + "static/media/unpin_line.56f2350bb71a63b84766d2e02987d65d.svg";
export { ForwardRef as ReactComponent };